//React
import React from 'react';

//pages
import { ReportManagement } from '../index';

import { useUserReportManagementData } from './useUserReportManagementData';

export const UserReportManagement: React.FC = () => {
  const {
    reports,
    sites,
    providers,
    remittances,
    submissions,
    payors,
    totalReports,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchReports,
    pagination,
    setPagination,
  } = useUserReportManagementData();
  return (
    <ReportManagement
      reports={reports}
      sites={sites}
      remittances={remittances}
      providers={providers}
      submissions={submissions}
      payors={payors}
      isError={isError}
      isLoading={isLoading}
      isFetching={isFetching}
      totalReports={totalReports}
      pagination={pagination}
      setPagination={setPagination}
      refetchReports={refetchReports}
      errorMessage={errorMessage}
    />
  );
};
